<template>
  <div class="contents">
    <div class="d-flex section-title-with-back" v-if="id">
      <img src="@/assets/images/Icon awesome-pen.png" alt="" width="27.3" height="25.2" />
      <p class="title-bk">ブランド編集</p>
    </div>
    <div class="d-flex section-title-with-back" v-else>
      <img src="@/assets/images/Icon awesome-plus-circle.png" alt="" width="25" height="25" />
      <p class="title-bk">ブランド登録</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: id ? 'brand-id-edit' : 'brand-add', params: id ? { id } : {} }">
        戻る
      </router-link>
    </div>
    <div class="container">
      <table class="table">
        <tbody>
          <tr>
            <th scope="row" width="30%">以下の内容で登録しますか？</th>
            <td />
          </tr>
          <tr>
            <th scope="row">法人名（法人ID）</th>
            <td>{{ currentCorporationDisplay }}</td>
          </tr>
          <tr>
            <th scope="row">ブランドID</th>
            <td>{{ currentBrand.uid }}</td>
          </tr>
          <tr>
            <th scope="row">ブランド名</th>
            <td>{{ currentBrand.name }}</td>
          </tr>
          <tr>
            <th scope="row">ブランド名(フリガナ)</th>
            <td>{{ currentBrand.nameReading }}</td>
          </tr>
          <tr>
            <th scope="row">郵便番号</th>
            <td>{{ currentBrand.postalCode }}</td>
          </tr>
          <tr>
            <th scope="row">都道府県 市区町村</th>
            <td>{{ currentBrand.state }}</td>
          </tr>
          <tr>
            <th scope="row">番地・建物名</th>
            <td>{{ currentBrand.address }}</td>
          </tr>
          <tr>
            <th scope="row">電話番号</th>
            <td>{{ currentBrand.phone }}</td>
          </tr>
          <tr>
            <th scope="row">FAX番号</th>
            <td>{{ currentBrand.fax }}</td>
          </tr>
          <tr>
            <th scope="row">メールアドレス</th>
            <td>{{ currentBrandEmail }}</td>
          </tr>
        </tbody>
      </table>
      <div class="text-center">
        <button type="button" class="btn-confirm" @click="confirmRevised">修正</button>
        <button type="button" class="btn-red" @click="confirmSaved" :disabled="isLoading">登録</button>
      </div>
      <PopUpHolder
        ref="popup_holder"
        no-close-on-esc
        no-close-on-backdrop
        green-button-title="ブランド情報に戻る"
        @greenClick="popupConfirmed"
      >
        <template v-slot:header v-if="id">ブランド編集</template>
        <template v-slot:header v-else>ブランド登録</template>
        <template v-slot:body v-if="id">ブランドの登録情報の編集が完了しました！</template>
        <template v-slot:body v-else>ブランドの登録が完了しました！</template>
      </PopUpHolder>
      <b-alert variant="danger" v-show="errorMessage" dismissible show>{{ errorMessage }}</b-alert>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import store from '@/store/index.js';
import { basicPresent } from '@/presenters/fields';
import PopUpHolder from '@/components/popups/PopUpHolder.vue';
import { basicCorporationNameIdPresent } from '@/presenters/fields';

export default {
  props: {
    id: {
      type: [String, Number],
      required: false,
    },
  },
  components: {
    PopUpHolder,
  },
  data() {
    return {
      errorMessage: null,
      isLoading: false,
    };
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (routeTo.params.id) {
      if (store.getters['brand/existsUpdateRequiredParams']) {
        store.dispatch('brand/fetchBrand', routeTo.params.id).then(() => {
          next();
        });
      } else {
        next({ name: 'brand-id-edit', params: { id: routeTo.params.id } });
      }
    } else {
      if (store.getters['brand/existsRegistrationRequiredParams']) {
        next();
      } else {
        next({ name: 'brand-add' });
      }
    }
  },
  computed: {
    currentBrand() {
      if (this.brand.editingBrand) {
        return this.brand.editingBrand;
      } else {
        return this.brand.brand;
      }
    },
    currentCorporationDisplay() {
      return basicCorporationNameIdPresent(this.currentBrand.corporation);
    },
    currentBrandEmail() {
      return basicPresent(this.currentBrand.email);
    },
    ...mapState(['brand']),
  },
  methods: {
    confirmRevised() {
      if (this.id) {
        // This path is for Editing existing Brand flow
        this.$logger.debug('Need revise, go back to ID ' + this.id);
        this.$router.push({ name: 'brand-id-edit', params: { id: this.id } });
      } else {
        // This path is for Adding new Brand flow
        this.$logger.debug('Need revise, go back');
        this.$router.push({ name: 'brand-add' });
      }
    },
    confirmSaved() {
      this.$logger.debug('Finished Editing: ' + JSON.stringify(this.currentBrand));
      if (this.id) {
        // This path is for Editing existing Brand flow
        this.finishEditingBrand(this.id).then(
          (response) => {
            this.$logger.debug('Show success popup ' + response);
            this.$refs['popup_holder'].show();
          },
          (error) => {
            this.errorMessage = error;
            this.$logger.debug('Error ' + error);
          }
        );
      } else {
        this.isLoading = true;
        // This path is for Adding new Brand flow
        this.finishEditingBrand().then(
          (response) => {
            this.$logger.debug('Show success popup ' + response);
            this.$refs['popup_holder'].show();
          },
          (error) => {
            this.isLoading = false;
            this.errorMessage = error;
            this.$logger.debug('Error ' + error);
          }
        );
      }
    },
    popupConfirmed() {
      this.$logger.debug('Popup done');
      if (this.id) {
        this.$router.push({ name: 'brand-id-detail', params: { id: this.id } });
      } else {
        this.$router.push({ name: 'brand' });
      }
    },
    ...mapActions('brand', ['finishEditingBrand']),
  },
};
</script>

<style scoped>
.btn-confirm {
  margin-left: 0px;
}
</style>
